import React, {useId} from 'react';

import './FormField.css';
import Select from '../ui/Select/Select';

const FormField = ({
  onKeyDown,
  label,
  type = 'text',
  name,
  value,
  onChange,
  error,
  selectTagErr,
  placeholder,
  modifierClassesFormField,
  children,
  required,
  onBlur,
  onFocus,
  maxLength,
  options,
  isMulti = false, // добавляем поддержку мультиселекта
}) => {
  const generatedId = useId();

  const handleSelectChange = (selectedOptions) => {
    if (isMulti) {
      onChange({target: {name, value: selectedOptions}});
    } else {
      onChange({target: {name, value: selectedOptions}});
    }
  };

  return (
    <div className={`form-field ${modifierClassesFormField?.field || ''}`}>
      <label
        className={`auth-forms__title-input ${
          modifierClassesFormField?.label || ''
        }`}
        htmlFor={generatedId}
      >
        {label}{' '}
        <span
          className={`auth-forms__title-input-required ${
            error ? 'error-message_red' : ''
          }`}
        >
          {required ? '*' : ''}{' '}
        </span>
      </label>
      <div
        className={`auth-forms__wrapper-input ${
          modifierClassesFormField?.inputWrapper || ''
        }`}
      >
        {type === 'select' ? (
          <Select
            id={generatedId}
            name={name}
            value={value}
            onChange={handleSelectChange}
            options={options}
            optionsErrors={selectTagErr || []}
            placeholder={placeholder}
            isMulti={isMulti}
            className={modifierClassesFormField}
          />
        ) : type === 'textarea' ? (
          <textarea
            id={generatedId}
            name={name}
            className={`auth-forms__textarea ${
              modifierClassesFormField?.input || ''
            }`}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            maxLength={maxLength}
          />
        ) : (
          <input
            id={generatedId}
            type={type}
            name={name}
            className={`auth-forms__input ${
              modifierClassesFormField?.input || ''
            }`}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            autoComplete={type === 'password' ? 'current-password' : 'off'}
            onKeyDown={onKeyDown}
          />
        )}
        {children}
        {error && <p className='auth-forms__error-message'>{error}</p>}
      </div>
    </div>
  );
};

export default FormField;
